export function convertToArabic(input = "") {
    input = input == null ? "" : String(input);
    const map = {
        0: "٠",
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        a: "أ",
        b: "ب",
        j: "ح",
        d: "د",
        r: "ر",
        s: "س",
        x: "ص",
        t: "ط",
        e: "ع",
        g: "ق",
        k: "ك",
        l: "ل",
        z: "م",
        n: "ن",
        h: "هـ",
        u: "و",
        v: "ى",
    };
    return input.replace(/[0-9a-z]/gi, (c) => map[c.toLowerCase()] || c);
}

export function convertToEnglish(input = "") {
    input = input == null ? "" : String(input);
    const map = {
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        أ: "A",
        ا: "A",
        ب: "B",
        ح: "J",
        د: "D",
        ر: "R",
        س: "S",
        ص: "X",
        ط: "T",
        ع: "E",
        ق: "G",
        ك: "K",
        ل: "L",
        م: "Z",
        ن: "N",
        هـ: "H",
        و: "U",
        ى: "V",
        ي: "V",
    };
    return input.replace(/[٠-٩ا-ي]/g, (c) => map[c] || c);
}

export function extractNumber(input = "") {
    input = input == null ? "" : String(input);
    const match = input.match(/\d+/);
    return match ? match[0] : "";
}

export function insertSpacesIfMissing(input = "") {
    input = input == null ? "" : String(input);
    return input.replace(/([a-zA-Z])(?=[a-zA-Z])/g, "$1 ");
}

export function extractText(input = "") {
    input = input == null ? "" : String(input);
    const withSpaces = insertSpacesIfMissing(input);
    const match = withSpaces.match(/[a-zA-Z\s]+/g);
    return match ? match.join("") : "";
}

export function renderPlate(plateNumber, containerId, options = {}) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const letters = extractText(plateNumber);
    const numbers = extractNumber(plateNumber);

    const sizeScale =
        options.size === "small" ? 0.7 : options.size === "large" ? 1.4 : 1;
    const bgColor = options.bgColor || "#fff";
    const textColor = options.textColor || "#000";

    container.innerHTML = `
        <div class="car-number-image" style="
            position: relative; 
            bottom: 0; 
            right: 0; 
            display: inline-block; 
            transform: scale(${sizeScale}); 
            transform-origin: top right; 
            background: ${bgColor}; 
            color: ${textColor}; 
            border-radius: 8px;
        ">
            <div class="inner p-0">
                <div class="cont sudi" style="border-color:  ${textColor};">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 47 54.5" fill="${textColor}"
                        height="16">
                        <path 
                            d="M17.8,15.2c-2.3,1.6-4,3.7-5.3,6.1.1-1.8.6-3.5,1.6-5,.9-1.6,2.2-2.8,3.7-3.8-2.6.8-4.7,2.4-6.3,4.5.5-1.8,1.3-3.3,2.6-4.6,1.3-1.2,2.9-2,4.6-2.5-1.1-.1-2.2,0-3.3.1s-2.1.6-3.1,1.2c1.1-1.6,3.5-3.8,8.6-3.3-1.4-.7-2.8-1-4.3-.8,0-.2.1-.2.2-.2,1.9-1.1,3.8-1.2,5.8-.3.3.1.4,0,.5-.2.3-.8.6-1.6.9-2.4.2,0,.1.1.2.2.3.7.6,1.4.9,2.2.1.3.2.3.5.2,1.9-.9,3.8-.9,5.6.2.1,0,.3.2.4.3-1.5-.1-2.9.1-4.2.8,1.6,0,3.2,0,4.8.5s2.8,1.5,3.8,2.9c-1-.5-2-.9-3.1-1.2s-2.2-.3-3.3-.1c1.7.6,3.3,1.3,4.6,2.5,1.3,1.3,2.1,2.8,2.6,4.6-1.7-2.1-3.7-3.7-6.3-4.5,1.4,1.1,2.7,2.3,3.7,3.8.9,1.5,1.5,3.2,1.6,5-1.3-2.5-3.1-4.5-5.3-6.2,2.4,3.2,3.3,6.8,2.7,10.8-.7-3.2-2.2-6.1-4.3-8.6,1.2,3.6,1,7.1-.5,10.6,0-2.3-.1-4.5-.8-6.7-.3-.9-.6-1.7-1.1-2.5-.1-.2-.3-.5-.5-.7-.1,1.1-.2,2.2-.3,3.3,0,.1,0,.2.1.2.2,0,.2,0,.2.3-.1,1.2-.2,2.4-.4,3.6,0,.2,0,.3.2.3.2,0,.2.2.2.3-.1,1.2-.2,2.4-.4,3.6,0,0-.1.3,0,.3.4,0,.3.2.3.4-.1,1.2-.2,2.3-.4,3.5,0,.2,0,.3.2.4.3.3.7.6,1,.9,0,0,0,0,0,0h-4.6c.3-.3.6-.7.9-.9.2-.2.2-.3.2-.6-.1-1.2-.2-2.4-.4-3.6,0-.1,0-.3.1-.3.3,0,.3-.2.2-.4-.1-1.2-.2-2.4-.3-3.6,0-.2,0-.3.2-.3.2,0,.1-.2.1-.3-.1-1.2-.2-2.4-.4-3.6,0-.2,0-.3.2-.3.1,0,.2,0,.1-.2-.1-1.1-.2-2.2-.4-3.3-2,3-2.5,6.4-2.4,9.9-1.5-3.4-1.8-6.9-.5-10.5-2.2,2.5-3.6,5.4-4.3,8.6-.6-4,.2-7.6,2.7-10.8h0s0,0,0,0Z" />
                        <path
                            d="M3.9,32.6c.7-.3,1.4-.5,2.2-.7,3.7-.7,7.1.2,10.3,2,2.5,1.4,4.7,3.1,6.8,5,.2.1.3.2.5.4.3.3.4.2.7,0,2-1.8,4-3.5,6.3-4.9,2-1.2,4.2-2.2,6.5-2.6,2.4-.4,4.7-.1,6.9.7-.5,0-.9,0-1.4,0-4.4.4-8.3,2-12,4.4-1.7,1.1-3.4,2.4-5,3.7-.2.2-.3.3,0,.5.9.8,1.8,1.6,2.7,2.4.2.2.3.2.5,0,.6-.7,1.1-1.4.8-2.4,0-.2,0-.2.2-.1.4,0,.6.3.8.7.2.6.1,1.2-.1,1.8-.2.4-.4.7-.7,1.1-.1.1-.1.2,0,.3.6.5,1.1.9,1.8,1.3.1,0,.3.1.4.2.8.2,1.2,0,1.4-.8.2-.7.6-1,1.3-.9.5,0,.9.6.9,1.1.1,1.3-.7,2.5-2.1,2.7-1.1.2-2.2,0-3.1-.7-.6-.4-1.2-1-1.8-1.5-.2-.1-.2-.1-.4,0-.6.7-1.1,1.4-.9,2.4,0,.2,0,.2-.2.2-.4-.1-.6-.4-.7-.7-.2-.5,0-1,0-1.4.1-.4.4-.9.7-1.2.2-.2.2-.3,0-.6-1-.8-2-1.7-2.9-2.5-.2-.2-.3-.2-.5,0-1,.9-2,1.7-3,2.6-.2.2-.2.2,0,.4.6.6.9,1.4.9,2.2,0,.6-.3,1-.7,1.2-.2,0-.4.1-.3-.2.2-1-.3-1.7-1-2.4-.1-.2-.2,0-.3,0-.7.5-1.3,1.1-2.1,1.6-1.1.7-2.2.8-3.5.3-1.1-.4-1.6-1.3-1.5-2.5,0-.6.5-1.1,1.1-1.2.6,0,1,.2,1.2.9.2.8.7,1.1,1.4.8.9-.3,1.5-.9,2.2-1.5.1-.1,0-.2,0-.3-.2-.3-.5-.6-.6-1-.2-.5-.3-1-.3-1.5,0-.5.4-.9.8-1,.2,0,.3,0,.2.2-.2,1,.3,1.8.9,2.4.1.1.2,0,.3,0,.9-.9,1.9-1.7,2.8-2.5.1-.1.1-.2,0-.3-3.9-3.2-7.9-6-12.8-7.4-1.7-.5-3.4-.8-5.2-.8-.1,0-.2,0-.4,0h0s0,0,0,0Z" />
                    </svg>
                    <span class="c-name-ar">السعودية</span>
                    <div class="c-name-en">
                        <span>K</span><span>S</span><span>A</span>
                    </div>
                </div>
                <div class="cont char" style="border-color:  ${textColor};">
                    <div class="char ar" style="border-color:  ${textColor};">${convertToArabic(
        letters
    )}</div>
                    <div class="char en">${convertToEnglish(letters)}</div>
                </div>
                <div class="cont number" style="border-color:  ${textColor};">
                    <div class="number ar" style="border-color:  ${textColor};">${convertToArabic(
        numbers
    )}</div>
                    <div class="number en" style="border-color:  ${textColor};">${convertToEnglish(
        numbers
    )}</div>
                </div>
            </div>
        </div>
    `;
}

window.renderPlate = renderPlate;
window.convertToArabic = convertToArabic;
window.convertToEnglish = convertToEnglish;
window.extractNumber = extractNumber;
window.extractText = extractText;
